import CommonDialog, { CommonDialogProps } from '@/../../common/src/components/CommonDialog';
import { useEffect, useState } from 'react';

function GlobalDialog() {
  const [props, setProps] = useState<CommonDialogProps>({});

  useEffect(() => {
    window.showGlobalDialog = (dialogProps: CommonDialogProps) => {
      setProps({
        ...dialogProps,
        visible: true,
        onCancel: (e) => {
          setProps({
            ...dialogProps,
            visible: false,
          });
          dialogProps.onCancel?.(e);
        },
        onConfirm: async (e) => {
          dialogProps.onConfirm && (await dialogProps.onConfirm?.(e));
          setProps({
            ...dialogProps,
            visible: false,
          });
        },
      });
    };
    return () => {
      window.showGlobalDialog = undefined;
    };
  }, []);

  return <CommonDialog {...props} />;
}

export default GlobalDialog;
